import { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { popModal } from '@/redux/modals/actions';
import { urlWithoutSessionId } from '@/util/sessionIdExtractor';

export const useLeaveModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useCallback(
    (to: string) => {
      dispatch(popModal());
      navigate(urlWithoutSessionId(), { replace: true });
      navigate(to);
    },
    [dispatch, navigate]
  );
};
